
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'
import { NotificationType } from '@/const/NotificationType'
import DateUtils from '@/utils/DateUtils'

/**
 * お知らせ一覧の一行分のレイアウト
 */
@Component({
  components: {
    ImageBase,
    LinkBase,
  },
})
export default class NoticeListElement extends Vue {
  /** メッセージ情報 */
  @Prop()
  private message!: NoticeMessageData

  /**
   * お知らせタイプのコードから、タイプのラベルを引き当てて返す
   *
   * @returns お知らせタイプのラベル
   */
  private get messageType(): string {
    const type = NotificationType.findByCode(this.message.type)
    return type?.label || ''
  }

  /**
   * お知らせの日付を成形する
   *
   * @returns フォーマットされた日付
   */
  private get date(): string {
    const start = DateUtils.format(this.message.startedDate)
    const end = DateUtils.format(this.message.endedDate)
    return DateUtils.startToEnd(start, end)
  }

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   */
  private clickEvent(): void {
    this.$emit('click')
  }
}
